import { isErrorWithStatus } from '.';

export const isInactiveWorkspaceError = isErrorWithStatus( 403, 'inactive_workspace' );
export const isSubscriptionLimitError = isErrorWithStatus( 403, 'forbidden_subscription_limit_reached' );
export const isFreeTrialLimitError = isErrorWithStatus( 403, 'forbidden_project_count' );
export const isMemberNotFoundError = isErrorWithStatus( 404, 'not_found_member' );
